import React from "react";
import GroupStyle from "./style";
import { LeftOutlined } from "@ant-design/icons";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Space,
  message,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";
import UseApi from "../../Reusable/CallApi/UseApi";


// NOTE ON FIELD CHANGES:
// The real `tymeplushrlmsgroup` table / addgroup API expects:
//   groupName, description, groupKey, enterGroupkey, maximumLimit
// The original mock form had Name / Description / Price. Price isn't part
// of the Group entity, so it's been swapped out for Group Key / Enter Group
// Key / Maximum Limit so the Create button actually persists real data.
const AddGroup = ({ editData }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { loading, request } = UseApi();
  const clientId = useSelector(
    (state) => state.authTracking.userInfo.clientId
  );

  const onFinish = async (values) => {
    try {
      // Phase 1 - API 1: POST /group/addgroup/{clientId}
      await request({
        endPoint: `/group/addgroup/${clientId}`,
        method: "post",
        data: {
          groupName: values.name,
          description: values.description,
          groupKey: !!values.groupKey,
          enterGroupkey: values.enterGroupkey || "",
          maximumLimit: values.maximumLimit ?? null,
        },
      });

      message.success("Group created successfully");
      navigate("/group");
    } catch (error) {
      message.error("Failed to create group");
    }
  };

  const handlGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <GroupStyle>
        <div className="component_return_header">
          <LeftOutlined className="back_icon" onClick={handlGoBack} />
          <span className="user-menu-title">Add Group</span>
        </div>
        <br></br>
        <div>
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
              groupKey: false,
            }}
            form={form}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter your name!",
                },
              ]}
              className="form_input_label"
            >
              <Input className="" />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              className=""
              rules={[
                {
                  required: true,
                  message: "Please enter description!",
                },
              ]}
            >
              <TextArea />
            </Form.Item>

            <Form.Item name="groupKey" valuePropName="checked">
              <Checkbox>Group Key</Checkbox>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prev, cur) => prev.groupKey !== cur.groupKey}
            >
              {({ getFieldValue }) =>
                getFieldValue("groupKey") ? (
                  <Form.Item
                    label="Enter Group Key"
                    name="enterGroupkey"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the group key!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                ) : null
              }
            </Form.Item>

            <Form.Item label="Maximum Limit" name="maximumLimit">
              <InputNumber className="input_price_field" min={0} />
            </Form.Item>

            <Form.Item className="add_group_button_section">
              <Space>
                <Button htmlType="submit" loading={loading}>
                  Save
                </Button>
                <NavLink to="/group">
                  <Button>Cancel</Button>
                </NavLink>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </GroupStyle>
    </>
  );
};

export default AddGroup;
